import * as constants from '../constants';

const initialState = {
    results: []
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getRegistrants.success: {
            return action.payload;
        }

        default:
            return state;
    }
}
